import { motion } from 'framer-motion';

const FADE_INITIAL = { opacity: 0, y: 24 };
const FADE_ANIMATE = { opacity: 1, y: 0 };
const FADE_VIEWPORT = { once: true, amount: 0.2 };

const STAGGER_VIEWPORT = { once: true, amount: 0.15 };
const STAGGER_VARIANTS_FACTORY = (amount) => ({
  hidden: {},
  show: { transition: { staggerChildren: amount } },
});

const STAGGER_ITEM_VARIANTS = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } },
};

export const FadeUp = ({ children, delay = 0, className = '', as = 'div' }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={FADE_INITIAL}
      whileInView={FADE_ANIMATE}
      viewport={FADE_VIEWPORT}
      transition={{ duration: 0.7, ease: 'easeOut', delay }}
      className={className}
    >
      {children}
    </Comp>
  );
};

export const Stagger = ({ children, className = '', amount = 0.15 }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={STAGGER_VIEWPORT}
    variants={STAGGER_VARIANTS_FACTORY(amount)}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = '' }) => (
  <motion.div variants={STAGGER_ITEM_VARIANTS} className={className}>
    {children}
  </motion.div>
);
